import { DialogContentText } from '@mui/material';
import { ValidationCombinedFile } from '../core/global';
import { ColourOptions, getMarkerIcon } from '../helpers/marker-icons';
import styles from "../styles/components/organisation-validations.module.scss";
import { DeleteConfirmation } from './confirmation-buttons';
import { WarningMessage } from './error-message';
import { ImageModal, Img } from './image';
import { SettingsValidationsTable } from './settings-validations-table';
import { StyledMarkdown } from './typeface';


export const ValidationItemRow = ({
  items,
  showIcon = true,
  canEdit = false,
  onEdit = () => {},
}: {
  items: ValidationCombinedFile[],
  showIcon?: boolean
  canEdit?: boolean
  onEdit?: (item: ValidationCombinedFile) => void

}) => {
  const useItems = items || []
  if (useItems.length === 0) {
    return <div className={styles.validationItemRow}>
      <WarningMessage message={'No images uploaded with this validation point.'} />
    </div>
  }

  return <>
      {useItems.map( (item, index) => {
        const {file, content, type} = item
        const key = file ? (typeof file === 'string' ? file : file.name) : `validation-file-${index}`
        const icon = getMarkerIcon(`${type}Sym` as ColourOptions)
        return (
          <div className={styles.validationItemRow} key={key}>
            <div className={styles.validationIcons}>
              {file && <span>
                <ImageModal 
                  src={typeof file === 'string' ? file : URL.createObjectURL(file)} 
                  alt='validation thumbnail' width={60} />
                </span>
              }
              {(showIcon && icon) && <span><Img src={icon} alt='icon' width={25} /></span>}
              <span><strong>Type:</strong> {type}</span>
            </div>
            {content && 
              <div>
                <StyledMarkdown>
                  {`**Description:** ${content}`}
                </StyledMarkdown>
              </div>
            }

            {canEdit && <DeleteConfirmation
              onDelete={async () => {
                onEdit(item)
              }}
            />}

          </div>
        )
      })
    }
  </>
}


interface OrganisationValidationsProps {
  id: number | string | null;
}

export const OrganisationValidations = ({id}: OrganisationValidationsProps) => {
  return (
    <>
      <div className={styles.content}>
        <DialogContentText>
          <span>You can edit/add/remove private validation points. All members of your organisation will be able to see these validations. External users and collaborators will not be able to view these.</span>
        </DialogContentText>
      </div>
      <div className={styles.wrapper}>
        <SettingsValidationsTable isPublicValidation={false} organisationId={id} />
      </div>
    </>
  );
}

